import { render, staticRenderFns } from "./defaultLateral.vue?vue&type=template&id=073f30b7"
import script from "./defaultLateral.vue?vue&type=script&lang=js"
export * from "./defaultLateral.vue?vue&type=script&lang=js"
import style0 from "./defaultLateral.vue?vue&type=style&index=0&id=073f30b7&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports